import { OrderUtils } from '../../../orders/utils/order.utils';

/** Membership allowance line on a Monthly Wash tile: "Unlimited" or "Limited: 8 washes". */
export function formatMembershipAllowance(
  washCountPeriod?: string | null,
  washCountFrequency?: number | string | null
): string {
  const allowance = OrderUtils.formatMembershipLimitNoun(washCountPeriod, washCountFrequency);
  return OrderUtils.isUnlimitedMembershipWashLimit(washCountPeriod, washCountFrequency)
    ? allowance
    : `Limited: ${allowance.toLowerCase()}`;
}
